export enum ProfileLoadType {
  EDIT = 2,
  APPROVE = 3,
  INACTIVE = 6
}
